import { render, staticRenderFns } from "./pay-success copy.vue?vue&type=template&id=94fbfca8&scoped=true"
import script from "./pay-success copy.vue?vue&type=script&lang=js"
export * from "./pay-success copy.vue?vue&type=script&lang=js"
import style0 from "./pay-success copy.vue?vue&type=style&index=0&id=94fbfca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fbfca8",
  null
  
)

export default component.exports